import { useContext, useEffect } from 'react';
import { MainContext } from 'context';
import { getTheme, styled } from 'themes';
import { Container as ContainerElements } from 'elements';
import Logo from 'elements/logo';
import MainContent from 'compositions/main-content';
import ButtonStore from 'compositions/button-store';
import { ConfigFooterProps } from 'interface';

const FooterElement = styled('footer', {
  display: 'block',
  backgroundColor: '$light',
  fontFamily: '$default',
  paddingY: 45,
  paddingX: 32,
});

const Container = styled(ContainerElements, {
  display: 'flex',
  width: '100%',
  height: '100%',
  alignItems: 'center',
  flexDirection: 'row',

  '@media (max-width: 768px)': {
    flexDirection: 'column',
  },
});

function Footer({ emissor, portal }: ConfigFooterProps) {
  const { setState } = useContext(MainContext);

  useEffect(() => {
    setState({
      emissor,
      portal,
    });
  }, [emissor, portal, setState]);

  return (
    <FooterElement className={getTheme(emissor)}>
      <Container>
        <Logo />
        <MainContent />
        <ButtonStore />
      </Container>
    </FooterElement>
  );
}

export default Footer;
